import { render, staticRenderFns } from "./ekko.terms-of-service.vue?vue&type=template&id=2f9d3774&scoped=true&"
import script from "./ekko.terms-of-service.vue?vue&type=script&lang=ts&"
export * from "./ekko.terms-of-service.vue?vue&type=script&lang=ts&"
import style0 from "./ekko.terms-of-service.vue?vue&type=style&index=0&id=2f9d3774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9d3774",
  null
  
)

export default component.exports